export const languageList = ['nl', 'en', 'fr'] as const;

export type Language = (typeof languageList)[number];
